{
  "kodycard": "https://my.kodypay.com/kodycard/remoteEntry.json"
}
